import { RoutingRulesService } from './../../services/routing-rules.service';
import { AccessControlService } from 'src/app/services/access-control.service';
import { Component, OnInit, TemplateRef, ElementRef, ViewChild, ViewEncapsulation, Renderer2 } from '@angular/core';
import { IdpService } from 'src/app/services/identity-service/idp.service';
import { IdentityProvider } from 'src/app/model/idp.modals';
import { ApplicationIDP, AD, IDPSETTING } from 'src/app/model/application-idp.modals';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import * as Ladda from 'ladda';
import { environment } from 'src/environments/environment';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/services/auth.service';
import { RuleModel } from '../../model/rule.model'
import { RulesEnum } from '../../enum/rules.enum'
import { map } from 'rxjs/internal/operators/map';
import { switchMap } from 'rxjs/operators';
@Component({
  selector: 'app-app-idp',
  templateUrl: './app-idp.component.html',
  styleUrls: ['./app-idp.component.css']
})
export class AppIdpComponent implements OnInit {
  idpList: Array<IdentityProvider>;
  model: ApplicationIDP;
  modalRef: BsModalRef;
  saveButton: any;
  serviceUrl = environment.serverUrl;
  currentIdpId: any;
  currentIdpName: any;
  currentAppId: any;
  currentAppname: any;
  orgId: any;
  url: any;
  isEditMode = false;
  // currentIdpList:any;
  clientAppList: Array<any> = []
  clientId: string;
  selectApp = false;
  idpsList: Array<any> = []
  ruleModel: RuleModel = new RuleModel();
  routingRules: Array<any> = []
  selectedRule: RuleModel = new RuleModel()
  @ViewChild('idpTemplate') template: TemplateRef<any>;
  @ViewChild('idpAD') templateAd: TemplateRef<any>;
  @ViewChild('idpSocialTemplate') idpSocialTemplate: TemplateRef<any>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['Name', 'Type', 'Status', 'Actions']
  dataSource: MatTableDataSource<any>;
  noData: any;
  okta;
  isFb: boolean = true;
  isOkta: boolean = true;
  isGoogle: boolean = true;
  isOffice364: boolean = true;
  isMicrosoftAD: boolean = true;
  isLinkedin: boolean = true;
  isSalesforce:boolean=true;
  isBrightSpace: boolean = true;
  idpSettings: any = []
  applicationRoleList: any = []
  currentIdpList: Array<any> = []
  defaultRule = RulesEnum.DEFAULT_RULE
  selectedId = '0'
  showDropdown = false
  applicationsRole = []
  showRolesConfig = false;
  selectedClientApps = []
  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'value',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: false
  };
  clientAppListSetting = {
    singleSelection: false,
    idField: 'id',
    textField: 'application_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  listForEditedApp: any = []
  constructor(private idpService: IdpService, private modalService: BsModalService, private toastrService: ToastrService, private router: ActivatedRoute, private authService: AuthService, private accessControlService: AccessControlService, private routingRulesService: RoutingRulesService) { }

  ngOnInit() {
    // this.getAllIdps();
    // this.currentAppId = this.router.snapshot.params["id"];
    this.currentAppId = this.orgId = this.clientId = localStorage.getItem('org_id')
    // this.clientId=localStorage.getItem('user_id')
    this.currentAppname = this.router.snapshot.queryParams['app'];
    this.getApplicationIdp();
    this.getRoutingRules()
  }

  getAllIdps() {
    this.idpService.getAllIdps().subscribe(
      (list: any) => {
        this.idpList = <Array<IdentityProvider>>list.docs;
      }
    )
  }
  getApplicationIdp() {
    this.idpService.getAppIdps(this.orgId).subscribe(
      (list: any) => {
        this.dataSource = new MatTableDataSource<any>(list.data)
        this.dataSource.paginator = this.paginator;
        this.dataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'Type': return item.idp.provider;
            case 'Status': return item.idp.active;
            case 'Name': return item.idp.name
            default: return item['Name'];
          }
        };
        this.dataSource.sort = this.sort;
        this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
        this.currentIdpList = list.data || [];
        if (this.currentIdpList) {
          this.currentIdpList.forEach(element => {
            switch (element.idp.idp_id) {
              case 1:
                this.isOkta = false;
                break;
              case 2:
                this.isOffice364 = false;
                break;
              case 3:
                this.isGoogle = false;
                break;
              case 4:
                this.isFb = false;
                break;
              case 5:
                this.isMicrosoftAD = false;
                break;
              case 6:
                this.isLinkedin = false;
                break;
              case 8:
                this.isSalesforce = false;
                break;
              case 9:
                this.isBrightSpace = false;
                break;
              default:
                break;
            }
          });
        }
        if (this.idpList)
          this.idpList = this.idpList.filter(
            (element) => {
              if (this.currentIdpList.findIndex(x => x.idp_id == element._id) == -1) {
                return element;
              }
            }
          );
      }
    )
  }
  openConfigModalPopUp(idpId: any, appName: any, template: TemplateRef<any>) {
    let config = { backdrop: true, ignoreBackdropClick: true };
    // this.modalRef = this.modalService.show(template, config);
    // this.saveButton = Ladda.create(document.querySelector('.btn-save'));
    this.currentIdpId = idpId;
    this.currentIdpName = appName;
    if (!this.isEditMode) {
      this.model = new ApplicationIDP();
      if (idpId == 5)
        this.model.idp = new AD();
      else
        this.model.idp = new IDPSETTING();
      this.idpService.getIdpSettings(this.currentIdpId)
        .subscribe((settings: any) => {
          if (settings.data) {
            this.idpSettings = settings.data;
            this.model.idp.idpMapField = settings.data.idpFields[0].value
            this.model.idp.gsfMapField = settings.data.gsfFields[0].value
            this.model.idp.ifAccountNotFound = settings.data.ifAccountNotFound[0].id
            this.model.idp.scopes = [...settings.data.scopes]
            let suburlPart = '';
            switch (settings.data.idp_id) {
              case 1:
                suburlPart = "okta"
                break;
              case 2:
                suburlPart = "office365"
                break;
              case 3:
                suburlPart = "google"
                break;
              case 4:
                suburlPart = "facebook"
                break;
              case 6:
                suburlPart = "linkedin"
                break;
              case 8:
                suburlPart = "salesforce"
                break;
              case 9:
                suburlPart = "BrightSpace"
                break;
              default:
                suburlPart = null;// idpDetails.idp.provider="Undefined"
            }
            this.model.idp.callbackURL = environment.serverUrl + `single-auth/common/login/callback`;
            this.modalRef = this.modalService.show(template, config);
            // this.model.idp.defaultRole=settings.data.defaultRole||-1;
            this.saveButton = Ladda.create(document.querySelector('.btn-save'));
          }
        },
          (error) => {
            this.toastrService.error('Oops something went wrong', 'Error');
          })
    }
    else {
      this.idpService.getIdpSettings(this.currentIdpId)
        .subscribe((settings: any) => {
          if (settings.data) {
            this.idpSettings = settings.data
            this.modalRef = this.modalService.show(template, config);
            this.saveButton = Ladda.create(document.querySelector('.btn-save'))
          }
        },
          (error) => {
            this.toastrService.error('Oops something went wrong', 'Error');
          })
    }
  }
  addIdp(form: NgForm) {
    // this.model.idp.defaultRole=this.model.idp.ifAccountNotFound==1?-1:this.model.idp.defaultRole;
    if (!this.isEditMode) {
      this.model.idp.idp_id = this.currentIdpId;
      this.model.orgId = this.orgId
      // if(this.model.idp.ifAccountNotFound==1)
      this.idpService.addIdps(this.model).subscribe(
        (res: any) => {
          if (!res.error) {
            this.toastrService.success('Record saved successfully', 'Success');
            this.saveButton.stop();
            this.modalRef.hide();
            this.getApplicationIdp();
          }
          else {
            this.saveButton.stop();
            this.toastrService.error('Oops something went wrong', 'Error');
          }
        }
      );
    }
    else {
      this.idpService.update(this.model).subscribe(
        (res: any) => {
          if (!res.error) {
            this.toastrService.success('Record saved successfully', 'Success');
            this.saveButton.stop();
            this.modalRef.hide();
            this.getApplicationIdp();
          }
          else {
            this.saveButton.stop();
            this.toastrService.error('Oops something went wrong', 'Error');
          }
          this.isEditMode = false
        }
      );
    }
  }
  toggleClass() {
    this.showDropdown = !this.showDropdown
  }

  onEdit(eventData: any) {
    this.idpService.getIdpOfApplcationById(eventData.id).subscribe(
      (res: any) => {
        this.isEditMode = true;
        this.model = res.data;
        console.log(this.model)
        debugger;
        if (this.model.idp.ifAccountNotFound == 2) { this.getAllApplicationRoles(); }
        this.model.idp.defaultRole = this.model.idp.defaultRole || -1;

        if (eventData.providerType == 5)
          this.openConfigModalPopUp(this.model.idp.idp_id, eventData.appName, this.templateAd);
        else if (eventData.providerType == 3 || eventData.providerType == 4 || eventData.providerType == 6)
          this.openConfigModalPopUp(this.model.idp.idp_id, eventData.appName, this.idpSocialTemplate);
        else
          this.openConfigModalPopUp(this.model.idp.idp_id, eventData.appName, this.template);
      },
      error => {
        this.toastrService.error('Oops something went wrong', error.message);
      }
    )
  }
  onDelete(eventData: any) {
    Swal({
      title: 'Are you sure you want to delete?',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        Swal(
          'Deleted!',
          'Record deleted successfully',
          'success'
        ).then(() => {
          this.idpService.delete(eventData.id).subscribe(
            (res: any) => {
              if (!res.error) {
                const dsData = this.dataSource.data;
                const itemIndex = dsData.findIndex(element => element.appId == eventData.appId && element.idp_id == eventData.id);
                this.dataSource.data.splice(itemIndex, 1);
                this.dataSource.paginator = this.paginator
                this.toastrService.success('Record deleted successfully');
                this.refreshProvidersList(eventData.idpId)
                this.getRoutingRules(this.selectedId)
              }
              else
                this.toastrService.error('Oops something went wrong');
            },
            error => {
              this.toastrService.error('Oops something went wrong', error.message);
            }
          )
        })
      }
    });
  }
  refreshProvidersList(providerID) {
    switch (parseInt(providerID)) {
      case 1:
        this.isOkta = true
        break;
      case 2:
        this.isOffice364 = true
        break;
      case 3:
        this.isGoogle = true
        break;
      case 4:
        this.isFb = true
        break;
      case 5:
        this.isMicrosoftAD = true
        break;
      case 6:
        this.isLinkedin = true
        break;
      case 8:
        this.isSalesforce= true;
          break;
      case 9:
        this.isBrightSpace = true
        break;
    }
  }
  copyInputMessage(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.toastrService.success('Copied to clipboard');
  }
  closeModel() {
    this.modalRef.hide()
    this.isEditMode = false
    this.restoreRuleModel()

  }
  getAllApplicationRoles() {
    if (this.model.idp.ifAccountNotFound == 2)
      this.authService.listallRoles_withinApp(this.currentAppId).subscribe((res: any) => {
        this.applicationRoleList = res;
      })
  }

  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  openRuleModel(ruleTemplate: TemplateRef<any>, editMode = false) {
    this.accessControlService.getClientAppsWithMinDetails(this.clientId)
      .subscribe(
        (clientApps: any) => {
          if (clientApps.error) this.toastrService.error(clientApps.message)
          else {
            clientApps.data.applications = clientApps.data.applications.map((appDetails) => {
              appDetails.id = appDetails._id
              return appDetails
            })
            const applicationIds = clientApps.data.applications.map((appDetail) => appDetail.id)
            this.authService.getRolesForApplications(applicationIds).subscribe(
              (applicationRoles: any) => {
                if (applicationRoles.error) this.toastrService.error(applicationRoles.message)
                else {
                  this.applicationsRole = applicationRoles
                  this.idpService.getCLientIdps(this.clientId).subscribe(
                    (idpsList: any) => {
                      if (idpsList.error) this.toastrService.error(idpsList.message)
                      else {
                        this.clientAppList = clientApps.data.applications
                        this.idpsList = idpsList.data
                        if (editMode == false) {
                          this.ruleModel.identityProvider = null
                          this.ruleModel.customApplicationAccess = false
                          this.ruleModel.applications = this.clientAppList
                        }
                        else {
                          this.ruleModel = JSON.parse(JSON.stringify(this.selectedRule))
                          this.isEditMode = true
                          if (this.selectedRule.customApplicationAccess) this.selectApp = true
                          this.listForEditedApp = JSON.parse(JSON.stringify(this.selectedRule.applications))
                        }
                        console.log("Rule App", this.ruleModel.applications)
                        console.log("clientApps", this.clientAppList)
                        this.selectedClientApps = this.clientAppList
                        this.modalRef = this.modalService.show(ruleTemplate, {});
                      }
                    },
                    (error) => { this.toastrService.error(error.message) }
                  )
                }
              },
              (error) => { this.toastrService.error(error.message) }
            )
          }
        },
        (error) => { this.toastrService.error(error.message) }
      )
  }
  saveRule(ruleForm) {
    if (ruleForm.invalid) return
    this.ruleModel.clientId = this.clientId
    console.log(this.ruleModel)
    if (!this.isEditMode) {
      this.routingRulesService.addRoutingRule(this.ruleModel).subscribe(
        (response: any) => {
          if (!response.error) {
            this.toastrService.success("Record added successfully")
            this.modalRef.hide()
            this.restoreRuleModel()
            this.getRoutingRules(RulesEnum.DEFAULT_RULE)
          }
          else this.toastrService.error(response.message)
        },
        (error) => {
          this.toastrService.error(error.error.message)
        }
      )
    }
    else {
      this.routingRulesService.updateRoutingRule(this.clientId, this.selectedRule._id, this.ruleModel).subscribe(
        (response: any) => {
          if (!response.error) {
            this.toastrService.success("Record updated successfully")
            this.modalRef.hide()
            this.getRoutingRules(this.selectedRule._id)
            this.restoreRuleModel()
          }
          else this.toastrService.error(response.message)
        },
        (error) => {
          this.toastrService.error(error.error.message)
        }
      )
    }

  }
  appOption(option: boolean) {
    this.selectApp = option
    if (option && !this.isEditMode) {
      this.ruleModel.applications = []
    }
    if (!option) {
      for (let i = 0; i < this.clientAppList.length; i++)
        if (!this.ruleModel.applications.some((app) => app.id == this.clientAppList[i].id))
          this.ruleModel.applications.push(this.clientAppList[i])
    }
  }
  restoreRuleModel() {
    this.ruleModel = new RuleModel()
    this.selectApp = false
    this.isEditMode = false
    this.showRolesConfig = false
    this.selectedClientApps = []
  }
  getRoutingRules(selectRule = '0') {
    this.routingRulesService.getRoutingRule(this.clientId).subscribe(
      (response: any) => {
        if (!response.error) {
          this.routingRules = response.data
          this.selectRule(selectRule)
        }
      },
      (error) => {
        this.toastrService.error(error.message)
      }
    )
  }
  selectRule(ruleId) {
    this.selectedRule = this.routingRules.find((rule) => {
      return rule._id == ruleId
    })
    this.selectedId = this.selectedRule._id
  }
  editRule(ruleId, ruleTemplate) {
    this.selectRule(ruleId)
    this.openRuleModel(ruleTemplate, true)
  }
  compareFn(optionOne, optionTwo): boolean {
    if (optionOne && optionTwo) {
      return optionOne.id == optionTwo.id;
    }
  }
  deleteRule(ruleId) {
    Swal({
      title: 'Are you sure you want to delete?',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        this.routingRulesService.deleteRoutingRule(this.clientId, ruleId).subscribe(
          (response: any) => {
            if (!response.error) {
              this.toastrService.success("Rule deleted successfully")
              this.getRoutingRules()
            }
          },
          (err) => {
            this.toastrService.error(err.message)
          }
        )
      }
    })
  }
  changeActiveState(ruleId, state = true) {
    this.routingRulesService.changeActiveStatus(this.clientId, ruleId, { status: state }).subscribe(
      (response: any) => {
        if (!response.error) {
          const ruleIndex = this.routingRules.findIndex((rule) => {
            return rule._id == ruleId
          })
          if (ruleIndex >= 0) {
            this.routingRules[ruleIndex].isActive = state
          }
          this.toastrService.success(`Rule ${state ? 'enabled' : 'disabled'} successfully`)
        }
      },
      (err) => {
        this.toastrService.error(err.message)
      }
    )

  }
  checkUserCreationSetting(value) {
    const selectedIdp = this.currentIdpList.find((idp) => {
      return idp._id == value.id
    })
    if (selectedIdp.idp.ifAccountNotFound == 2) {
      this.showRolesConfig = true
      this.ruleModel.hasDefaultRole = true
    }
    else {
      this.showRolesConfig = false
      this.ruleModel.hasDefaultRole = false
      this.ruleModel.applications = this.ruleModel.applications.map((app) => {
        delete app.defaultRole
        return app
      })
      console.log("After deleted default role", this.ruleModel)
    }
  }
  selectRole(value) {
    const selectedApp = this.ruleModel.applications.findIndex((app) => {
      return app.id == value.applicationId
    })
    const roleExists = this.ruleModel.applications[selectedApp].defaultRole
    if (roleExists) {
      if (this.ruleModel.applications[selectedApp].defaultRole.id != value.id) {
        this.ruleModel.applications[selectedApp].defaultRole = ''
        this.ruleModel.applications[selectedApp].defaultRole = value
      }
    }
    else this.ruleModel.applications[selectedApp].defaultRole = value
  }
  getSelectedRoleName(appId) {
    if (this.selectedRule.applications.length > 0)
      return this.selectedRule.applications.find((app) => app.defaultRole.applicationId == appId).name
  }
  deSelect(value) {
    this.ruleModel.applications = this.ruleModel.applications.filter((app) => {
      return app.id != value.id
    })
  }
  deSelectAll(value) {
    this.ruleModel.applications = []
  }
  select(value) {
    this.ruleModel.applications.push({ ...value })
  }
  selectAll(value) {
    for (let i = 0; i < value.length; i++) {
      if (!this.ruleModel.applications.some((app) => app.id == value[i].id))
        this.ruleModel.applications.push(value[i])
    }
  }
}
